function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.213,6.821,8.167,3.74l-.042,9.194A1.07,1.07,0,0,1,7.05,14h0a1.071,1.071,0,0,1-1.066-1.076l.042-9.192L2.95,6.772a1.071,1.071,0,0,1-1.515-.006h0a1.072,1.072,0,0,1,.007-1.515l5.049-5A.879.879,0,0,1,7.734.261l5,5.053a1.071,1.071,0,0,1-.007,1.514h0A1.071,1.071,0,0,1,11.213,6.821Z",
  fill: "currentColor"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/arrow-up.353de0be.svg";
export { SvgComponent as ReactComponent };